import { Controller } from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {
    static targets = ["beforeVote", "afterVote", "showRating", "ratingGroup", "averageRating", "noRatingDescription", "showRatingPercent"];
    static values  = { url: String };

    connect() {
        this.selectedRating = 0;
        this.checkVoteStatus();
    }

    checkVoteStatus() {
        const hasVoted = this.getCookie('hasVoted');
        if (hasVoted === 'true') {
            this.showAfterVoteElements();
        } else {
            this.showBeforeVoteElements();
        }
    }

    showAfterVoteElements() {
        this.ratingGroupTarget.classList.add("d-none");
        this.averageRatingTarget.classList.remove("d-none");
        this.noRatingDescriptionTarget.classList.add("d-none");
        this.showRatingTarget.classList.remove("d-none");
        this.afterVoteTarget.classList.remove("d-none");
        this.beforeVoteTarget.classList.add("d-none");
    }

    showBeforeVoteElements() {
        this.ratingGroupTarget.classList.remove("d-none");
        this.averageRatingTarget.classList.add("d-none");
        this.noRatingDescriptionTarget.classList.remove("d-none");
        this.showRatingTarget.classList.add("d-none");
        this.afterVoteTarget.classList.add("d-none");
        this.beforeVoteTarget.classList.remove("d-none");
    }

    onRatingChange(event) {
        if (event.target.name === 'fst') {
            this.selectedRating = event.target.value;
            const locale = window.location.pathname.split("/")[1].toUpperCase();
            gtag("event", "vote", {
              site_language: locale.length > 2 || !locale ? "EN" : locale,
                title: event.params.title,
                category: event.params.category,
                index: event.params.index,
                rate: this.selectedRating
        });
          if (typeof rdt === "function") {
            rdt("track", "Custom", { customEventName: "vote" });
          }
            this.submitVote()
        }
    }

    submitVote() {
        this.setCookie('hasVoted', 'true', 365);
        // this.submitButtonTarget.classList.add("d-none");
        this.showAfterVoteElements();

        const pageId = this.ratingGroupTarget.getAttribute('data-page-id');
        const ratingText = this.averageRatingTarget;
        const ratingPercent = this.showRatingPercentTarget;

        const url = this.hasUrlValue ? this.urlValue : `/rating/static-page/${pageId}`;
        axios.post(url, { rating: this.selectedRating })
          .then(({ data }) => {
              const avg = Number(data.displayRating ?? data.averageRating);
              const votes = Number(data.totalVotes);
              ratingText.textContent = `${ratingText.dataset.average} ${avg.toFixed(1)}/5 ${ratingText.dataset.votes} ${votes}`.trim();
              ratingPercent.style.left = `${avg * 20}%`;
          })
          .catch(err => console.error("An error occurred:", err));
    }


    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        const path = window.location.pathname;
        document.cookie = `${name}=${value || ""}${expires}; path=${path}; SameSite=Lax`;
    }

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}
